import React, { createContext, useContext, useState } from "react";
import { defaultColorThemes } from "./ColorThemeSelector";

interface ColorThemeContextType {
  selectedTheme: string;
  currentColors: string[];
  setSelectedTheme: (theme: string) => void;
  colorThemes: typeof defaultColorThemes;
  setColorThemes: (themes: typeof defaultColorThemes) => void;
}

const ColorThemeContext = createContext<ColorThemeContextType | undefined>(
  undefined
);

export function ColorThemeProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const [selectedTheme, setSelectedTheme] = useState("default");
  const [colorThemes, setColorThemes] = useState(defaultColorThemes);

  const currentColors = colorThemes[selectedTheme as keyof typeof colorThemes];

  return (
    <ColorThemeContext.Provider
      value={{
        selectedTheme,
        currentColors,
        setSelectedTheme,
        colorThemes,
        setColorThemes,
      }}
    >
      {children}
    </ColorThemeContext.Provider>
  );
}

export function useColorTheme() {
  const context = useContext(ColorThemeContext);
  if (context === undefined) {
    throw new Error("useColorTheme must be used within a ColorThemeProvider");
  }
  return context;
}
